import React from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/Loading';

function DialogContent({ loading, text }) {
  if (loading) {
    return <Loading mode='dialog' />;
  }

  return <p>{text}</p>;
}

DialogContent.propTypes = {
  loading: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
};

export default DialogContent;
